const DAYS_SHORT   = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
const MONTHS_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

// How much of a gig's date is known (#429). The unknown parts of the stored
// date are placeholders, so they're never shown.
export type GigDatePrecision = "day" | "day_month" | "month" | "year"

function parts(dateStr: string) {
  const [y, m, d] = dateStr.split("-").map(Number)
  return { y, m, d }
}

// Gig lists are grouped under a year heading, so the year is left out.
// One day: "Fri 26 Jan". Multi-day: "26–29 Jan", or "31 Dec–2 Jan" across months.
// Partial dates: "28 Jan" (year unknown, so no weekday), "Jul" (month only),
// "Unknown" (year only, shown under its year heading).
export function formatGigDate(dateStr: string, endDateStr?: string | null, precision: GigDatePrecision = "day") {
  const start = parts(dateStr)
  if (precision === "year")      return "Unknown"
  if (precision === "month")     return MONTHS_SHORT[start.m - 1]
  if (precision === "day_month") return `${start.d} ${MONTHS_SHORT[start.m - 1]}`
  if (endDateStr && endDateStr !== dateStr) {
    const end = parts(endDateStr)
    if (end.y === start.y && end.m === start.m) {
      return `${start.d}–${end.d} ${MONTHS_SHORT[start.m - 1]}`
    }
    // Non-breaking spaces so a narrow column wraps after the dash, not mid-date.
    return `${start.d}\u00a0${MONTHS_SHORT[start.m - 1]}–${end.d}\u00a0${MONTHS_SHORT[end.m - 1]}`
  }
  const dow = DAYS_SHORT[new Date(start.y, start.m - 1, start.d).getDay()]
  return `${dow} ${start.d} ${MONTHS_SHORT[start.m - 1]}`
}
